module.exports = __webpack_public_path__ + "img/78.7987d9b5.jpg";